import { size as _size } from 'lodash-es';
import { dbAudience } from 'dbServer/collections';

export const fetchAudience = async () => {
	const audienceData = await dbAudience.getAudience();
	return !_size(audienceData) ? [] : audienceData;
};
